import * as THREE from 'three';
import lifegameVert from "../glsl/lifegame.vert";
import lifegameFrag from "../glsl/lifegame.frag";
import { QTreeDispQuads } from '../quads/QTreeDispQuads';
import { ShaderMaterial } from 'three';
import { QTreeRect } from '../myP5/drawer/QTreeRect';
import { ColorTex } from './ColorTex';


export class CAAreaVisualizer extends THREE.Object3D{


    quads:QTreeDispQuads;

    constructor(){
        super();

        this.quads = new QTreeDispQuads();
        this.add(this.quads);

    }

    public init(rects:QTreeRect[]):void{

        //console.log("init!! " + rects)

        this.quads.init(rects);
        this.quads.update();

    }

    public resize(x:number,y:number,w:number,h:number){

        this.quads.resize(x,y,w,h);

    }


}